import { z } from 'zod';
import { metaSchema } from './commun.zod';

export const PaymentSubscriptionStatusSchema = z.enum([
  'ACTIVE',
  'INACTIVE',
  'TRIAL',
  'CANCELLED',
  'EXPIRED',
  'PAST_DUE',
  'SUSPENDED',
]);

export const PaymentPlanTypeSchema = z.enum(['BASIC', 'ADVANCED', 'FREE']);

export const PaymentStatsSortBySchema = z
  .enum(['recent', 'oldest', 'name', 'status'])
  .default('recent');

export const PaymentStatsGroupsQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
  search: z.string().optional(),
  subscription_status: PaymentSubscriptionStatusSchema.optional(),
  plan_type: PaymentPlanTypeSchema.optional(),
  sortBy: PaymentStatsSortBySchema,
});

export const PaymentStatsSummarySchema = z.object({
  totalGroups: z.number().int(),
  paidGroups: z.number().int(),
  freeGroups: z.number().int(),
  withoutStripeCustomer: z.number().int(),
  estimatedMrr: z.number(),
  pastDueCount: z.number().int(),
  suspendedCount: z.number().int(),
  expiringWithin30Days: z.number().int(),
  bySubscriptionStatus: z.record(z.string(), z.number().int()),
  byPlanType: z.record(z.string(), z.number().int()),
  newGroupsLast30Days: z.number().int().optional(),
});

export const PaymentStatsGroupItemSchema = z.object({
  id: z.number().int(),
  name: z.string().nullable(),
  name_societe: z.string().nullable(),
  ville: z.string().nullable(),
  siret: z.string().nullable(),
  plan_type: z.string().nullable(),
  tier_id: z.string().nullable(),
  subscription_status: z.string().nullable(),
  date_subscribed: z.coerce.date().nullable(),
  date_echeance: z.coerce.date().nullable(),
  payment_failed_at: z.coerce.date().nullable(),
  suspended_at: z.coerce.date().nullable(),
  payment_warning_sent_at: z.coerce.date().nullable(),
  customer_id: z.string().nullable(),
  sub_id: z.string().nullable(),
  hasStripeCustomer: z.boolean(),
  estimatedMonthlyPrice: z.number(),
  userCount: z.number().int(),
  current_month_parcours: z.number().int().nullable(),
  max_parcours_per_month: z.number().int().nullable(),
  forfaitName: z.string().nullable(),
});

export const PaymentStatsGroupsResponseSchema = z.object({
  data: z.array(PaymentStatsGroupItemSchema),
  meta: metaSchema,
});

export type PaymentStatsGroupsQuery = z.infer<typeof PaymentStatsGroupsQuerySchema>;
export type PaymentStatsSummary = z.infer<typeof PaymentStatsSummarySchema>;
export type PaymentStatsGroupItem = z.infer<typeof PaymentStatsGroupItemSchema>;
export type PaymentStatsGroupsResponse = z.infer<typeof PaymentStatsGroupsResponseSchema>;
